
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);


if(document.getElementById('app_cdf') != null){
    document.addEventListener('alpine:init', () => {
        Alpine.data('app_cdf', (user, cdf, userCdf, routeUpdateNotification) => ({
            product : null,
            user : null,
            userCdf : null,
            routeUpdateNotification : null,
            init() {
                this.user = user;
                this.cdf = cdf;
                this.routeUpdateNotification = routeUpdateNotification;
                this.userCdf = this.prepareUserCdf(userCdf);
                // initialize main function
                this.checkAndUpdateAvailabilityCoupon();
                //this.loadProduct();
            },

            prepareUserCdf(userCdf){
                if(userCdf== null){
                    return;
                }
                userCdf.UI_coupon_nb_total = userCdf.customer_coupons.length;
                userCdf.UI_coupon_nb_waiting = 0;
                userCdf.UI_coupon_nb_done = 0;
                for (let kk = 0; kk < userCdf.customer_coupons.length; kk++) {
                    let customer_coupon = userCdf.customer_coupons[kk];
                    // les coupons sont masqué par default
                    customer_coupon.UI_is_display = false;
                    if(customer_coupon.used == 0){
                        userCdf.UI_coupon_nb_waiting++;
                        customer_coupon.UI_is_display = true;
                        customer_coupon.created_at_beautiful =  dayjs(customer_coupon.created_at).format('DD MMM YYYY');
                    }else if(customer_coupon.used_at != null){
                        customer_coupon.used_at_beautiful =  dayjs(customer_coupon.used_at).format('DD MMM YYYY');
                        userCdf.UI_coupon_nb_done++;
                    }
                }
                return userCdf;
            },
            isShowingAllCoupon : false,
            showAllCoupon(){
                if(this.isShowingAllCoupon){
                    this.userCdf = this.prepareUserCdf(this.userCdf);
                    this.isShowingAllCoupon = !this.isShowingAllCoupon;
                    return;
                }
                for (let kk = 0; kk < this.userCdf.customer_coupons.length; kk++) {
                    let customer_coupon = this.userCdf.customer_coupons[kk];
                    // les coupons sont masqué par default
                    if(!customer_coupon.UI_is_display){
                        customer_coupon.UI_is_display = true;
                    }
                }
                this.isShowingAllCoupon = !this.isShowingAllCoupon;
                return;
            },


            AddingNewCDF : false,
            AddNewCDF(){
                this.AddingNewCDF = true;

                axios.post(this.cdf.url_usernew, {'phone_number' : this.user.phone_number},{

                }).then(response =>{
                    if(response.data.success){
                        this.userCdf = this.prepareUserCdf(response.data.userCdf);
                    }
                    this.AddingNewCDF = false;
                }).catch(error => {
                    console.error("Une erreur est survenue :", error.message);
                    this.AddingNewCDF = false;
                });;
            },

            checkAndUpdateAvailabilityCoupon(){

                for (let i = 0; i < this.cdf.cdf_coupons_active.length; i++) {
                    let coupon = this.cdf.cdf_coupons_active[i];
                    if(typeof coupon.UI_PERCENT_AVAILABLE == "undefined"){
                        coupon.UI_PERCENT_AVAILABLE = 0;
                        if(userCdf != null){
                            for (let j = 0; j < this.userCdf.customer_pro.customer_soldes.length; j++) {
                                let solde = this.userCdf.customer_pro.customer_soldes[j];
                                if(solde.rewards_id == coupon.reward_id){
                                    coupon.UI_PERCENT_AVAILABLE = solde.compteur / coupon.price * 100;
                                    coupon.UI_SOLDE_AVAILABLE = solde.compteur;
                                }
                            }
                        }else{
                            coupon.UI_PERCENT_AVAILABLE = 0;
                            coupon.UI_SOLDE_AVAILABLE = 0;
                        }
                        coupon.UI_IS_BUYING = false;
                    }
                }
            },

            buyCoupon(coupon){
                if( coupon.UI_IS_BUYING){
                    return;
                }
                coupon.UI_IS_BUYING = true;

                axios.post(coupon.url_buycoupon, {},{

                }).then(response =>{
                    if(response.data.success){
                        this.closeModal();
                        this.userCdf = this.prepareUserCdf(response.data.userCdf);
                        this.cdf = response.data.cdf;
                        this.checkAndUpdateAvailabilityCoupon();
                    }
                    coupon.UI_IS_BUYING =  false;

                }).catch(error => {
                    console.error("Une erreur est survenue :", error.message);
                    coupon.UI_IS_BUYING =  false;
                });;
            },
            current_coupon_modal : null,
            loadModalBuyCoupon(coupon){
                this.current_coupon_modal = coupon;

                document.getElementById("my-modal-coupon_buy").checked = true;

            },

            closeModal(){

                this.$nextTick(() => {
                    document.getElementById("my-modal-coupon_buy").checked = false;

                })


            },
            addingMyNumberAndApplyToCampagn : false,
            formDataCampagn : {
                'phone_number' : null,
            },
            updateNotificationSettings(pro_id, notificationType, isChecked = false) {
                // Récupérer l'état actuel de la case à cocher
                if(!isChecked){
                     isChecked = event.target.checked;
                }


                this.userCdf.customer_pro.UI_show_update_success = false;


                // Effectuer une requête POST en fonction de l'état
                axios.post(this.routeUpdateNotification, {
                    'pro_id': pro_id,
                    'notificationType': notificationType,
                    'isChecked': isChecked,
                    'phone_number' : this.formDataCampagn.phone_number
                })
                .then(response => {
                    // Gérer la réponse si nécessaire
                    if(response.data.success){
                        this.updateCustomersPro(response.data.customerPro);
                        this.user = response.data.user;
                    }
                })
                .catch(error => {
                    console.error('Erreur lors de la mise à jour des paramètres de notification', error);
                });
            },
            updateCustomersPro(newCP){

                if(newCP.accept_email_campagn != this.userCdf.customer_pro.accept_email_campagn){
                    this.userCdf.customer_pro.accept_email_campagn = newCP.accept_email_campagn;
                    this.userCdf.customer_pro.UI_show_update_success = true;setTimeout(() => this.userCdf.customer_pro.UI_show_update_success = false, 1000)
                }
                if(newCP.accept_sms_campagn != this.userCdf.customer_pro.accept_sms_campagn){
                    this.userCdf.customer_pro.accept_sms_campagn = newCP.accept_sms_campagn;
                    this.userCdf.customer_pro.UI_show_update_success = true;setTimeout(() => this.userCdf.customer_pro.UI_show_update_success = false, 1000)
                }

            }

        }))
    })
}

